import {
  GET_ESTEL_LEDGER_TRANSACTION_TYPE_API,
  GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_SUCCESS,
  GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_FAILED,

  GET_ESTEL_LEDGER_DASHBOARD_API,
  GET_ESTEL_LEDGER_DASHBOARD_API_SUCCESS,
  GET_ESTEL_LEDGER_DASHBOARD_API_FAILED,

} from '../actions';

import { getTodaysDate } from "../../utils/common"
import config from "../../utils/config"
export const initialStateActivation = {
  segregatedData: [],
  filterValue: {
    selectedRegion: 'North',
    selectedState: 'Delhi',
    selectedRole: 'ZD - Shivalik Distribution Pvt Ltd - 0660002840',
    selectedRchain: '',
    selectedCategory: 'All',
    selectedPartnerRoleType: '754',
    selectedPartnerRoleName: 'ZD'
  },
  error: null,
  hierarchyData: null,
  mdnConnectivityData: null,
  headerSelectedDateFrom: getTodaysDate(config.startDate),
  headerSelectedDateTo: getTodaysDate(config.endDate),
  headerUnit: null,
  filteredArray: [],
  filterList: {
    loading: false,
    data: [],
    error: null
  },
  getAllAPI: {
    loading: false,
    data: {},
    error: null,
  },
  transactionTypeObj: {
    loading: false,
    error: null,
    transactionTypeData: {}
  },
  dashboardObj: {
    loading: false,
    error: null,
    dashboardData: {}
  }
};

export function estelLedgerReducer(state = initialStateActivation, action) {
  switch (action.type) {
    case GET_ESTEL_LEDGER_TRANSACTION_TYPE_API:
      return {
        ...state,
        transactionTypeObj: {
          loading: true,
          error: null,
          transactionTypeData: {}
        }
      }

    case GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_SUCCESS:
      let transactionTypeAPIData = JSON.parse(JSON.stringify(state.transactionTypeObj.transactionTypeData));
      transactionTypeAPIData = [action.payload.content];
      return {
        ...state,
        transactionTypeObj: {
          loading:false,
          error:null,
          transactionTypeData: Object.assign(state.transactionTypeObj.transactionTypeData, transactionTypeAPIData)
        }
      }   

    case GET_ESTEL_LEDGER_TRANSACTION_TYPE_API_FAILED:
      return {
        ...state,
        transactionTypeObj: {
          loading: false,
          error: action.error,
          transactionTypeData: {}
        }
      }

    case GET_ESTEL_LEDGER_DASHBOARD_API:
      return {
        ...state,
        dashboardObj: {
          loading: true,
          error: null,
          dashboardData: {}
        }
      }
    case GET_ESTEL_LEDGER_DASHBOARD_API_SUCCESS:
      let dashboardAPIData = JSON.parse(JSON.stringify(state.dashboardObj.dashboardData));
      dashboardAPIData = [action.payload.content];
      return {
        ...state,
        dashboardObj: {
          loading: false,
          error: null,
          dashboardData: Object.assign(state.dashboardObj.dashboardData, dashboardAPIData)
        }
      }
    case GET_ESTEL_LEDGER_DASHBOARD_API_FAILED:
      return {
        ...state,
        dashboardObj: {
          loading: false,
          error: action.error,
          dashboardData: {}
        }
      }

    default:
      return state;
  }
}

export default estelLedgerReducer